import { ActionHandler } from 'action-handler';

export default new ActionHandler({
  name: 'set_selected_clock',
  propName: 'selectedClock',
  defaultState: {
    selectedClock: null
  },
  handler(selectedClock) {
    return {
      selectedClock
    };
  },
  reduce(state, { selectedClock }) {
    return {
      selectedClock
    };
  }
});
